import React from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Dialog } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const DialogAlertForFullScreenDialog = (props) => {
  const { t, open, toggle, confirm, message } = props;

  return (
    <Dialog
      className="m-2 align-items-end"
      style={{ bottom: 'auto' }}
      open={open}
    >
      <div
        className="modal-dialog--warning modal-alert d-flex flex-column justify-content-center"
        style={{ height: '16rem' }}
      >
        <div className="modal__header d-flex flex-column align-items-center">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <span className="lnr lnr-flag modal__title-icon" />
          <h4 className="bold-text  modal__title">{t('warnings.title')}</h4>
        </div>
        <div className="modal__body text-center pl-3 pr-3">{message}</div>
        <ButtonToolbar className="modal__footer">
          <Button color="danger" onClick={toggle}>
            {t('general.cancel')}
          </Button>
          <Button color="success" onClick={confirm}>
            {t('general.confirm')}
          </Button>
        </ButtonToolbar>
      </div>
    </Dialog>
  );
};

DialogAlertForFullScreenDialog.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};
export default withTranslation('common')(DialogAlertForFullScreenDialog);
